import Seo from "@/components/base/Seo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import LatestNews from "@/pages/home/components/LatestNews";
import HotSidebar from "@/pages/home/components/HotSidebar";
import HotRecommend from "@/pages/home/components/HotRecommend";
import TopicsShowcase from "@/pages/home/components/TopicsShowcase";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <>
      <Seo
        title="噜噜社 - 综合娱乐资讯与潮流文化平台"
        description="噜噜社为您提供最新的娱乐资讯、潮流文化内容和丰富的互动体验，涵盖音乐、影视、时尚等多个领域，打造多元化的信息交流平台。"
        keywords="噜噜社,娱乐资讯,潮流文化,影视音乐,时尚潮流,互动平台"
      />
      <HeroCarousel />
      <CategoryShortcuts />
      <section className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 pt-2 md:px-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <LatestNews />
        </div>
        <HotSidebar />
      </section>
      <HotRecommend />
      <TopicsShowcase />
      <SiteIntro />
    </>
  );
}